// ============================================================================
//  DADES DEMO DE L'ÀREA DE CLIENTS  —  TOT FICTICI, SENSE BACKEND
//  Edita aquest fitxer per canviar les credencials o les dades d'exemple.
// ============================================================================
import { PRODUCTS } from "@/data/products";

export const DEMO_CLIENT = { name: "Lluís", company: "Diesel PaCo" };

// Credencials de la demo (comparació sense accents ni majúscules)
export const checkCredentials = (user, pass) => {
  const norm = (s) =>
    (s || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  return norm(user) === "lluis" && norm(pass) === "bingen";
};

export const eur = (n) =>
  n.toLocaleString("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

// Històric de comandes de demo (sense estats)
export const DEMO_ORDERS = [
  { id: "DP-2607", date: "2026-07-02", items: 2, total: 1290 },
  { id: "DP-2603", date: "2026-06-18", items: 1, total: 640 },
  { id: "DP-2598", date: "2026-06-03", items: 4, total: 2145 },
  { id: "DP-2590", date: "2026-05-12", items: 1, total: 480 },
];

// Estoc i preus de demo: es generen de forma determinista a partir de cada
// article del catàleg (així no cal tocar products.js)
const seedFrom = (s) => [...String(s)].reduce((a, c) => (a * 31 + c.charCodeAt(0)) >>> 0, 7);

export const STOCK_ROWS = PRODUCTS.map((p) => {
  const seed = seedFrom(p.id + p.ref);
  return {
    id: p.id,
    ref: p.ref,
    name: p.name,
    stock: seed % 14,
    price: 240 + (seed % 60) * 15,
  };
});
